/**
 * Shared framer-motion presets (kept from the NeonPulse template: the
 * [0.22, 1, 0.36, 1] ease, fade-up and staggered children).
 * MotionConfig reducedMotion="user" in App.js disables transforms for
 * visitors who prefer reduced motion.
 */
export const ease = [0.22, 1, 0.36, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease } },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 1, ease } },
};

export const stagger = (staggerChildren = 0.12, delayChildren = 0) => ({
  hidden: {},
  visible: { transition: { staggerChildren, delayChildren } },
});

/**
 * Props for a block that animates once when scrolled into view.
 * Triggers when any part is 10% inside the viewport. A fractional `amount`
 * would never fire for blocks taller than viewport/amount (e.g. long event
 * pages or menus on phones), leaving them invisible. The parameter is kept
 * for call-site compatibility.
 */
export const revealOnScroll = (_amount) => ({
  initial: "hidden",
  whileInView: "visible",
  viewport: { once: true, amount: "some", margin: "0px 0px -10% 0px" },
});
